// Centralized build type detection based on REACT_APP_TYPE

const resolveBuildType = () => {
  const raw = process.env.REACT_APP_TYPE;
  const normalized = typeof raw === 'string' ? raw.trim().toUpperCase() : '';
  if (normalized === 'STUDENTS' || normalized === 'TEACHERS' || normalized === 'ADMIN' || normalized === 'DEMO' || normalized === 'LANDING') {
    return normalized;
  }
  return 'ADMIN';
};

const BUILD_TYPE = resolveBuildType();

export const getBuildType = () => BUILD_TYPE;
export const isStudentsBuild = () => BUILD_TYPE === 'STUDENTS';
export const isTeachersBuild = () => BUILD_TYPE === 'TEACHERS';
export const isAdminBuild = () => BUILD_TYPE === 'ADMIN';
export const isDemoBuild = () => BUILD_TYPE === 'DEMO';
export const isLandingBuild = () => BUILD_TYPE === 'LANDING';

const AppStatic = {
  getBuildType,
  isStudentsBuild,
  isTeachersBuild,
  isAdminBuild,
  isDemoBuild,
  isLandingBuild
};

export default AppStatic;


